module.exports = __webpack_public_path__ + "static/media/Openflo@3x.9f33f547.png";